// extracted by mini-css-extract-plugin
export default {"wrapper":"Select_wrapper__i1YZ+","hasError":"Select_hasError__HQQBd"};